import logo from './cloud-computing.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          此域名尚未绑定，请联系技术客服。
        </p>
      </header>
    </div>
  );
}

export default App;
